// @ts-nocheck
import * as selectors from './popupsSelectors';

export { selectors };
